import React, { useEffect, useRef, useLayoutEffect } from "react";
import { Box, Card, Divider, TableBody } from "@mui/material";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import Paginator from "../../../toolkit/Paginator";
import RightArrowOpen from "../../../icons/RightArrowOpen.svg";
import Restoreicon from "../../../icons/Restoreicon.svg";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import { useState } from "react";
import { MenuItem } from "@mui/material";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import _ from "lodash";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import axios from "../../../utils/fvAxios";
import BaseUrl from "../../../utils/base-uri.json";
import { isArray } from "lodash";
import LoadingSpinner from "../../../toolkit/LoadingSpinner";
import ErrorAlert from "../../../toolkit/ErrorAlert";
import { FormatToLocalTimeString } from "../../../utils/dateFormat";
import GetfVDateFormate from "../../../utils/Genaricfunctions";
import {
  KeyboardArrowDown,
  KeyboardArrowUp,
  UnfoldMore,
} from "@mui/icons-material";
import debounce from 'lodash/debounce';

import { useNavigate } from "react-router-dom";


const queryUrl =
  BaseUrl.baseUrl + BaseUrl.OnsiteOffsite.GetEmployeeCheckinDetails;
const pageSize = 10;

const toQueryString = (obj) => {
  return "?".concat(
    Object.keys(obj)
      .map((e) => {
        if (isArray(obj[e])) {
          var d = obj[e]?.map(
            (r, idx) => `${e}[${idx}]=${encodeURIComponent(r)}`
          );
          return d.join("&");
        }
        return obj[e]
          ? `${encodeURIComponent(e)}=${encodeURIComponent(obj[e])}`
          : null;
      })
      .filter((e) => !!e)
      .join("&")
  );
};

const getUrl = (url, data) => `${url}${toQueryString(data)}`;

export default function ByCompany({ businessUnitId, locationId, clientId }) {
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.action.hover,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
      marginBottom: "20px",
    },
  }));
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: 50 * 5 + 8,
        width: 200,
      },
    },
  };

  const navigate = useNavigate();
  const handleClick = (event, vendorID) => {
    axios.get(BaseUrl.baseUrl + BaseUrl.OnsiteOffsite.GetPrequalificationDetail + "?vendorID=" + vendorID)
      .then((response) => {
        if (response?.data?.responseCode === 100) {
          if (event.ctrlKey) {

            window.open("/GetClientEmployees?Vendor=" + response?.data?.data?.vendorID + "&Client=" + response?.data?.data?.clientId + "&pqId=" + response?.data?.data?.prequalificationId, "_blank");

          } else {
            window.location = "/GetClientEmployees?Vendor=" + response?.data?.data?.vendorID + "&Client=" + response?.data?.data?.clientId + "&pqId=" + response?.data?.data?.prequalificationId;
          }
          //navigate("/GetClientEmployees?Vendor=" + response?.data?.data?.vendorID + "&Client=" + response?.data?.data?.clientId + "&pqId=" + response?.data?.data?.prequalificationId);
        }
      }).catch((err) => setError(err));
  };

  const [pageCount, setPageCount] = useState(1);
  const [pageNumber, setPageNumber] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [Searchdebounce, setSearchdebounce] = useState("");
  const [refresh, setRefresh] = useState(true);
  const [vendorEmployees, setVendorEmployees] = useState(null);
  const [vendors, setVendors] = useState(null);
  const [vendorId, setVendorId] = useState(1);
  const [tagNumber, setTagNumber] = useState();
  const [badgeNumber, setBadgeNumber] = useState();
  const [open, setOpen] = useState(false);
  const [isBadgeDisabled, setIsBadgeDisabled] = useState(false);
  const [isTagDisabled, setIsTagDisabled] = useState(false);
  const [permissions, setPermissions] = useState({
    hasTagPermission: false,
    hasBadgePermission: false,
  });
  const [orderBy, setOrderBy] = useState({
    sortingColumn: "Name",
    sortAscending: true,
  });
  const [isReseting, setIsReseting] = useState(false);

  const [selectedVendor, setSelectedVendor] = useState({
    vendorId: null,
    empId: null,
  });
  const [paramsState, setParamsState] = useState({
    vendorID: vendorId,
    buId: businessUnitId,
    locId: locationId,
    pageSize: 10,
    pageNumber: pageNumber,
    search: searchValue,
    orderBy: orderBy.sortingColumn,
    sortOrder: orderBy.sortAscending ? "ASC" : "DESC",
  });
  // const prevParamsStateRef = useRef(paramsState);

  useEffect(() => {
    if (locationId != 1) {
      axios
        .get(
          BaseUrl.baseUrl +
          BaseUrl.OnsiteOffsite.GetVendors +
          "clientID=" +
          clientId +
          "&businessUnitId=" +
          businessUnitId +
          "&businessUnitSiteId=" +
          locationId
        )
        .then((resp) => {
          if (resp?.data?.responseMessage === "Success") {
            setVendors(resp?.data?.data);
            setVendorId(1);
          }
        })
        .catch((err) => console.log(err));
    }
  }, [locationId]);

  // useLayoutEffect(() => {
  //   let isMounted = true;

  //   const fetchData = async () => {
  //     if (locationId !== 1) {
  //       try {
  //         setLoading(true);
  //         const url = getUrl(queryUrl, { ...paramsState });
  //         const res = await axios.get(url);
  //         if (isMounted) {
  //           if (res?.data?.responseMessage === 'Success') {
  //             const data = res?.data?.data?.sanitizedResult;
  //             setVendorEmployees(data);
  //             setPageCount(
  //               Math.ceil((res?.data?.count || pageSize) / pageSize)
  //             );
  //             setPermissions({
  //               hasTagPermission: res?.data?.data?.hasPermission,
  //               hasBadgePermission: res?.data?.data?.hasBadgePermission,
  //             });
  //           }
  //         }
  //       } catch (err) {
  //         if (isMounted) {
  //           setError(err);
  //         }
  //       } finally {
  //         if (isMounted) {
  //           setLoading(false);
  //           setRefresh(false);
  //         }
  //       }
  //     }
  //   };

  //   if (refresh) {
  //     if (searchValue === Searchdebounce) {
  //       fetchData();
  //     }
  //   }

  //   return () => {
  //     isMounted = false;
  //   };
  // }, [paramsState, refresh, searchValue, Searchdebounce]);

  useEffect(() => {
    if (refresh) {
      if (locationId !== 1) {
        if (searchValue === Searchdebounce) {
          setLoading(true);
          const url = getUrl(queryUrl, { ...paramsState });
          axios.get(url)
            .then((res) => {
              if (res?.data?.responseMessage === 'Success') {
                const data = res?.data?.data?.sanitizedResult;
                setVendorEmployees(data);
                setPageCount(
                  Math.ceil((res?.data?.count || pageSize) / pageSize)
                );
                setPermissions({
                  hasTagPermission: res?.data?.data?.hasPermission,
                  hasBadgePermission: res?.data?.data?.hasBadgePermission,
                });
              } else {
                setError(res?.data?.responseMessage);
              }
            })
            .catch((err) => setError(err))
            .finally(() => {
              setLoading(false);
              setRefresh(false);
            });
        }
      }
    }
  }, [paramsState, refresh, searchValue, Searchdebounce]);

  useEffect(() => {    // when change B-unit or location reset api
    setVendorId(1);
    setSearchValue("");
    setSearchdebounce("");
    setParamsState((prev) => ({ ...prev, search: "", pageNumber: 1, vendorID: 1 }));
    setRefresh(true);
  }, [locationId, businessUnitId]);

  useEffect(() => {
    setParamsState((prev) => ({
      ...prev,
      buId: businessUnitId,
      locId: locationId,
      pageNumber: 1,
    }));
    setRefresh(true);
  }, [locationId]);



  const delayedSearch = debounce((value) => {
    setSearchdebounce(value)
    setPageNumber(1);
    setParamsState((prev) => ({
      ...prev,
      search: value,
      pageNumber: 1,
    }));
    setRefresh(true);
  }, 2000);

  const changeSearchValue = (e) => {
    const { value } = e.target;
    setSearchValue(value);
    delayedSearch(value);
  };

  const changeVendor = (value) => {
    setVendorId(value);
    setSearchValue("");
    setSearchdebounce("");
    setParamsState((prev) => ({ ...prev, vendorID: value, search: "", pageNumber: 1, }));
    setRefresh(true);
  };
  const setPage = (pageNumber) => {
    if (pageNumber > 0) {
      setPageNumber(pageNumber);
      setParamsState((prev) => ({ ...prev, pageNumber }));
      if (pageNumber > 1 && searchValue != "" && Searchdebounce != "") {
        setRefresh(true);
        setPageNumber(pageNumber);
      } else if (pageNumber > 0 && searchValue == "" && Searchdebounce == "") {
        setRefresh(true);
        setPageNumber(pageNumber);
      }
    }
  };

  // setpagenumber((prevPageNumber) => {
  //   if (prevPageNumber !== pageNumber) {
  //     setRefresh(true); // Trigger refresh if the page number has changed
  //     return pagenumber;
  //   } else {
  //     setRefresh(false); // Do not refresh if the page number hasn't changed
  //     return prevPageNumber; // Keep the page number the same
  //   }
  // });

  const changeTagNumber = (value) => {
    const numericInput = value?.replace(/[^0-9]/g, "");
    if (numericInput.length <= 4) setTagNumber(numericInput);
    else setTagNumber(numericInput.substring(0, 4));
  };

  const changeBadgeNumber = (value) => {
    const numericInput = value?.replace(/[^0-9]/g, "");
    if (numericInput.length <= 4) setBadgeNumber(numericInput);
    else setBadgeNumber(numericInput.substring(0, 4));
  };



  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleClickOpen = (vendorId, empId, tagNumber, badgeNumber) => {
    // if (tagNumber) {
    //   setIsTagDisabled(true);
    //   setTagNumber(tagNumber);
    // }
    // if (badgeNumber) {
    //   setIsBadgeDisabled(true);
    //   setBadgeNumber(badgeNumber);
    // }
    setSelectedVendor({ vendorId, empId });
    setOpen(true);
  };

  const chekcInUser = (ID, VID, EID) => {
    const { vendorId, empId } = selectedVendor;
    const data = {
      vendorEmployeeID: ID == 1 ? EID : empId,
      vendorID: ID == 1 ? VID : vendorId,
      tagNumber: tagNumber,
      badgeNumber: badgeNumber,
      userType: 1,
      clientBusinessUnitSiteID: locationId,
      clientBusinessUnitID: businessUnitId,
    };
    axios
      .post(BaseUrl.baseUrl + BaseUrl.OnsiteOffsite.CheckinUser, data)
      .then((resp) => {
        if (resp?.data?.data === "Success") {
          setRefresh((prev) => !prev);
        }
      }).catch((err) => setError(err))
      .finally(() => {
        handleClose();
      });
  };

  const checkoutEmployee = (onsiteOffsiteID, employeeID, vendorID) => {
    const data = {
      onsiteOffsiteID: onsiteOffsiteID,
      vendorEmployeeID: employeeID,
      vendorID: vendorID,
      clientBusinessUnitID: businessUnitId,
      clientBusinessUnitSiteID: locationId,
    };
    axios
      .post(BaseUrl.baseUrl + BaseUrl.OnsiteOffsite.CheckoutEmployee, data)
      .then((resp) => {
        if (resp?.data?.data === "Success") {
          setRefresh((prev) => !prev);
        }
      }).catch((err) => setError(err));
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedVendor({ vendorId: null, empId: null });
    setTagNumber(undefined);
    setIsTagDisabled(false);
    setBadgeNumber(undefined);
    setIsBadgeDisabled(false);
  };

  const handleResetVisitor = (onsiteOffsiteId) => {
    setIsReseting(true);
    axios
      .post(
        BaseUrl.baseUrl + BaseUrl.OnsiteOffsite.ResetEmployee + onsiteOffsiteId,
        {}
      )
      .then((resp) => {
        if (resp?.data?.data === "Success") {
          setRefresh((prev) => !prev);
        }
      }).catch((err) => setError(err))
      .finally(() => {
        setIsReseting(false);
      });
  };

  const sortTable = (sortingColumn) => {
    if (orderBy?.sortingColumn === sortingColumn) {
      setOrderBy((prev) => ({
        ...prev,
        sortAscending: !orderBy.sortAscending,
      }));
    } else {
      setOrderBy({
        sortingColumn,
        sortAscending: true,
      });
    }
  };

  useEffect(() => {
    setParamsState((prev) => ({
      ...prev,
      orderBy: orderBy?.sortingColumn,
      sortOrder: orderBy?.sortAscending ? "ASC" : "DESC",
    }));
    setRefresh(true);
  }, [orderBy]);

  return (
    <>
      <Dialog fullScreen={fullScreen} open={open} onClose={handleClose}>
        <DialogContent sx={{ padding: "48px 48px" }}>
          <DialogTitle
            sx={{
              textAlign: "center",
              fontWeight: 500,
              fontSize: 20,
            }}
          ></DialogTitle>
          <DialogActions>
            <div>
              <div>
                {permissions?.hasTagPermission && (
                  <div>
                    <span style={{ color: "#3E4A62" }}>Tag Number </span>
                    <br />
                    <TextField
                      placeholder="Tag Number"
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        fontFamily: "Arial, FontAwesome",
                      }}
                      variant="outlined"
                      size="small"
                      value={tagNumber}
                      disabled={isTagDisabled}
                      onChange={(e) => changeTagNumber(e.target.value)}
                    />
                  </div>
                )}

                {permissions?.hasBadgePermission && (
                  <div className="mt-3">
                    <span style={{ color: "#3E4A62" }}>Badge Number</span>
                    <br />

                    <TextField
                      placeholder="Badge Number"
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        fontFamily: "Arial, FontAwesome",
                      }}
                      variant="outlined"
                      size="small"
                      value={badgeNumber}
                      disabled={isBadgeDisabled}
                      onChange={(e) => changeBadgeNumber(e.target.value)}
                    />
                  </div>
                )}
              </div>

              <DialogActions>
                <div className="login-help__buttonContainer mt-4">
                  <Button
                    variant="contained"
                    className="login-help-button-cancel mx-2"
                    onClick={handleClose}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    className="login-button-request mx-2"
                    onClick={chekcInUser}
                  >
                    Submit
                  </Button>
                </div>
              </DialogActions>
            </div>
          </DialogActions>
        </DialogContent>
      </Dialog>
      <Card>
        <div style={{ marginLeft: "10px", padding: "10px", color: "red" }}>
          This tab is for finding employees by vendor company (select company
          from dropdown list and click the Get Employees button). You can check
          them both in and out <br></br> from this screen. (Some users will see
          a popup window to enter a tag and/or badge number. After clicking
          "Submit," the name will disappear.)
        </div>
        <Divider
          sx={{
            marginTop: 2,
            marginBottom: 2,
            backgroundColor: "#667085;",
            height: "2px",
          }}
        />
        <div style={{ marginLeft: "15px", marginBottom: "15px" }}>
          <Stack spacing={2} direction="row">
            <TextField
              placeholder="Search"
              value={searchValue}
              onChange={changeSearchValue}
              sx={{
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
                fontFamily: "Arial, FontAwesome",
              }}
              variant="outlined"
              size="small"
            />
            <div style={{ marginLeft: "Auto" }}>
              <FormControl sx={{ m: 1, width: 300 }}>
                <Select
                  labelId="demo-multiple-name-label"
                  id="demo-multiple-name"
                  value={vendorId}
                  size="small"
                  onChange={(e) => changeVendor(e.target.value)}
                  MenuProps={MenuProps}
                >
                  <MenuItem key={-1} value={1}>
                    Select Vendor
                  </MenuItem>
                  {vendors &&
                    vendors?.map((vendor) => (
                      <MenuItem
                        key={vendor?.id}
                        title={vendor?.name}
                        value={vendor?.id}
                      >
                        {vendor?.name +
                          " - " +
                          vendor?.prequalificationStatusName}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </div>
          </Stack>
        </div>
        <Box sx={{ backgroundColor: "#f8f9fa" }}>
          {loading ? (
            <LoadingSpinner />
          ) : vendorEmployees?.length > 0 ? (
            <TableContainer component={Paper} sx={{ borderBottom: 0 }}>
              <Table aria-label="customized table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell onClick={() => sortTable("Name")}>
                      <span style={{ color: "#667085", fontSize: "16px" }}>
                        Employee Name
                      </span>
                      <IconButton>
                        {orderBy?.sortingColumn === "Name" ? (
                          orderBy?.sortAscending ? (
                            <KeyboardArrowUp />
                          ) : (
                            <KeyboardArrowDown />
                          )
                        ) : (
                          <UnfoldMore />
                        )}
                      </IconButton>
                    </StyledTableCell>
                    <StyledTableCell>
                      <span style={{ color: "#667085", fontSize: "16px" }}>
                        Pass Orientation
                      </span>
                    </StyledTableCell>
                    {permissions?.hasTagPermission && (
                      <StyledTableCell onClick={() => sortTable("TagNumber")}>
                        <span style={{ color: "#667085", fontSize: "16px" }}>
                          Tag #
                        </span>
                        <IconButton>
                          {orderBy?.sortingColumn === "TagNumber" ? (
                            orderBy?.sortAscending ? (
                              <KeyboardArrowUp />
                            ) : (
                              <KeyboardArrowDown />
                            )
                          ) : (
                            <UnfoldMore />
                          )}
                        </IconButton>
                      </StyledTableCell>
                    )}
                    {permissions?.hasBadgePermission && (
                      <StyledTableCell onClick={() => sortTable("BadgeNumber")}>
                        <span style={{ color: "#667085", fontSize: "16px" }}>
                          Badge #
                        </span>
                        <IconButton>
                          {orderBy?.sortingColumn === "BadgeNumber" ? (
                            orderBy?.sortAscending ? (
                              <KeyboardArrowUp />
                            ) : (
                              <KeyboardArrowDown />
                            )
                          ) : (
                            <UnfoldMore />
                          )}
                        </IconButton>
                      </StyledTableCell>
                    )}
                    <StyledTableCell>
                      <span style={{ color: "#667085", fontSize: "16px" }}>
                        Onsite
                      </span>
                    </StyledTableCell>
                    <StyledTableCell>
                      <span style={{ color: "#667085", fontSize: "16px" }}>
                        Offsite
                      </span>
                    </StyledTableCell>
                    <StyledTableCell>
                      <span style={{ color: "#667085", fontSize: "16px" }}>
                        Reset
                      </span>
                    </StyledTableCell>
                  </TableRow>
                </TableHead>

                {vendorEmployees?.map((r, i) => {
                  const showInfo =
                    i === 0 ||
                    r?.employeeID !== vendorEmployees[i - 1].employeeID;
                  return (
                    <TableBody key={i}>
                      <TableRow key={i}>
                        <StyledTableCell sx={{ width: "20%" }}>
                          {showInfo && (
                            <span
                              className="text-primary cursor-pointer"
                              onClick={(event) =>
                                handleClick(event, r?.vendorID)}
                            >
                              {r?.lastName + ", " + r?.firstName}</span>
                          )}
                        </StyledTableCell>

                        <StyledTableCell sx={{ width: "15%" }}>
                          <span
                            style={{
                              fontSize: "14px",
                              color:
                                r.passedOrientation == "No"
                                  ? "#EE3F3F"
                                  : "#12B76A",
                            }}
                          >
                            {showInfo && <span>{r?.passedOrientation}</span>}
                          </span>
                        </StyledTableCell>

                        {permissions?.hasTagPermission && (
                          <StyledTableCell sx={{ width: "15%" }}>
                            <span style={{ fontSize: "initial" }}>
                              {r?.tagNumber}
                            </span>
                          </StyledTableCell>
                        )}

                        {permissions?.hasBadgePermission && (
                          <StyledTableCell sx={{ width: "15%" }}>
                            <span style={{ fontSize: "initial" }}>
                              {r?.badgeNumber}
                            </span>
                          </StyledTableCell>
                        )}

                        <StyledTableCell sx={{ width: "20%" }}>
                          {r?.checkin == null ? (
                            <div style={{ cursor: (r.locked) ? 'not-allowed' : '' }}>
                              <IconButton
                                aria-label="OpenArrow"
                                onClick={() => {
                                  permissions?.hasTagPermission == false && permissions?.hasBadgePermission == false
                                    ?
                                    chekcInUser(
                                      1,
                                      r?.vendorID,
                                      r?.employeeID,
                                    )
                                    :
                                    handleClickOpen(
                                      r?.vendorID,
                                      r?.employeeID,
                                      r?.oldTagId === 0 ? undefined : r?.oldTagId,
                                      r?.oldBadgeId === 0 ? undefined : r?.oldBadgeId
                                    )
                                }
                                }
                                disabled={r?.locked}
                              >
                                <span>
                                  {" "}
                                  <img
                                    src={RightArrowOpen}
                                    alt="OpenArrow"
                                  />{" "}
                                  <span
                                    style={{
                                      color: "#2A93DB",
                                      fontSize: "initial",
                                    }}
                                  >
                                    Onsite
                                  </span>{" "}
                                </span>
                              </IconButton>
                            </div>
                          ) : (
                            GetfVDateFormate("", "", r?.checkin)
                          )}
                        </StyledTableCell>
                        <StyledTableCell sx={{ width: "20%" }}>
                          {r?.checkout == null ? (
                            <div
                              style={{ cursor: (r?.locked) ? 'not-allowed' : '' }}
                            >
                              <IconButton
                                aria-label="OpenArrow"
                                onClick={() =>
                                  checkoutEmployee(
                                    r?.onsiteOffsiteID,
                                    r?.employeeID,
                                    r?.vendorID
                                  )
                                }
                                disabled={r?.locked}
                              >
                                <span>
                                  {" "}
                                  <img
                                    src={RightArrowOpen}
                                    alt="OpenArrow"
                                  />{" "}
                                  <span
                                    style={{
                                      color: "#2A93DB",
                                      fontSize: "initial",
                                    }}
                                  >
                                    Offsite
                                  </span>{" "}
                                </span>
                              </IconButton>
                            </div>
                          ) : (
                            GetfVDateFormate("", "", r?.checkout)
                          )}
                        </StyledTableCell>

                        <StyledTableCell sx={{ width: "20%" }}>
                          <div
                            style={{ cursor: (r?.locked || isReseting || (r?.checkin === null && r?.checkout === null)) ? 'not-allowed' : '' }}
                          >
                            <IconButton
                              aria-label="Restoreicon2"
                              disabled={
                                r?.locked ||
                                isReseting ||
                                (r?.checkin === null && r?.checkout === null)
                              }
                              onClick={() => {
                                handleResetVisitor(r?.onsiteOffsiteID);
                              }}
                            >
                              <span>
                                {" "}
                                <img src={Restoreicon} alt="Restoreicon2" />{" "}
                                <span
                                  style={{
                                    fontSize: "initial",
                                    color: "#2A93DB",
                                  }}
                                >
                                  Reset
                                </span>{" "}
                              </span>
                            </IconButton>
                          </div>
                        </StyledTableCell>
                      </TableRow>
                    </TableBody>
                  );
                })}
              </Table>
            </TableContainer>
          ) : error ? (
            <ErrorAlert message={error} />
          ) : (
            <ErrorAlert severity="warning" message={"No results found!"} />
          )}
        </Box>
      </Card>
      {!loading && vendorEmployees?.length > 0 && (
        <Paginator
          count={pageCount}
          page={Number(pageNumber)}
          margin="18px 0px"
          onChange={setPage}
        />
      )}
    </>
  );
}
